import { IEkatenaCDAResponse } from '../interfaces/ekatenaInterfaces';
import { apiURL } from '../utils/constants'
import { message } from "antd"
import { Fonts } from "../utils/constants";

export const PostEkatenaReport = (rfc: string, ciec: string): Promise<IEkatenaCDAResponse> => {
    return new Promise((resolve, reject) => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const body = JSON.stringify({
        'rfc': rfc,
        'ciec': ciec
        });

        fetch(apiURL+ '/EkatenaRequest', 
            {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow',
                body
            })
            .then(response => response.json())
            .then(response => resolve(response))
            .catch(error => {
                reject(error)
                message.error({ content: 'Error al realizar la consulta, por favor intente de nuevo', style: { fontFamily: Fonts.sspRegular } });
            })
    });
}